import { render, staticRenderFns } from "./orderBid.vue?vue&type=template&id=05dcd422&scoped=true&"
import script from "./orderBid.vue?vue&type=script&lang=js&"
export * from "./orderBid.vue?vue&type=script&lang=js&"
import style0 from "./orderBid.vue?vue&type=style&index=0&id=05dcd422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dcd422",
  null
  
)

export default component.exports